import React from 'react';
import PropTypes from 'prop-types';

import DialogContent from '@material-ui/core/DialogContent';
import { DialogActions } from '@material-ui/core';
import { FormattedMessageWrappedInSpan } from '../../misc';

import CustomDialog from './CustomDialog';

const HowToUseThatsMeDialog = ({ open, onRequestClose, onGoBackToMainSearch }) => {
  return (
    <CustomDialog open={open} onRequestClose={onRequestClose}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body">
            <h1>
              <FormattedMessageWrappedInSpan
                id="howToUseThatsMeDialog.title"
                defaultMessage="Use main search to tag photos"
              />
            </h1>
            <FormattedMessageWrappedInSpan
              id="howToUseThatsMeDialog.instruction"
              defaultMessage="Tagging photos is currently disabled. To enable it, use the main search first."
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="howToUseThatsMeDialog.acceptButton"
                defaultMessage="OK"
              />
            </button>
            {onGoBackToMainSearch && (
              <button className="accept" onClick={onGoBackToMainSearch}>
                <FormattedMessageWrappedInSpan
                  id="howToUseThatsMeDialog.backToMainSearch"
                  defaultMessage="Go to main search"
                />
              </button>
            )}
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

HowToUseThatsMeDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onGoBackToMainSearch: PropTypes.func,
};

export default HowToUseThatsMeDialog;
